export default {
    find: "/find",
    section: "/section",
    reporter: "/reporter",
    admin: "/admin"
}